import React, { Component } from 'react';

class ContentWrapper extends Component {

    render() {

        var childElement = this.props.children;

        // unwrapped pages
        if (this.props.unwrap) {
            childElement = <div className="unwrap">{this.props.children}</div>;
        }

        return (
            <div className="content-wrapper" style={this.props.style}>
                {childElement}
            </div>
        );
    }

}

export default ContentWrapper;



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/ContentWrapper.jsx